'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _LockOutlined = _interopRequireDefault(require('./lib/icons/LockOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _LockOutlined;
exports.default = _default;
module.exports = _default;